{
    "ClientConfigurationModal_AddTitle": "Adicionar configuração do cliente",
    "ClientConfigurationModal_ChangeTitle": "Alterar configuração do cliente",
    "ClientConfigurationModal_Footer_Actions_Submit": "Enviar",
    "ClientConfigurationModal_Footer_Actions_Cancel": "Cancelar",
    "ClientConfigurationModal_Footer_Actions_Help": "Ajuda",
    "ClientConfigurationModal_Tabs_Details": "Detalhes",
    "ClientConfigurationModal_Tabs_Scope": "Escopo",
    "ClientConfigurationModal_Tabs_Policy": "Política",
    "ClientConfigurationModal_Tabs_Settings": "Configurações",
    "ClientConfigurationModal_Tab_Details_Description": "Descrição",
    "ClientConfigurationModal_Tab_Details_Description_Required": "Descrição é necessária",
    "ClientConfigurationModal_Tab_Details_ID": "EU IA",
    "ClientConfigurationModal_Tab_Details_ID_Placeholder": "[Atribuição automática]",
    "ClientConfigurationModal_Tab_Details_Override": "Substituir todas as configurações do cliente",
    "ClientConfigurationModal_Tab_Scope_CME": "CME",
    "ClientConfigurationModal_Tab_Scope_Telsys": "Servidor de Telefonia",
    "ClientConfigurationModal_Tab_Scope_Telsys_Required": "Servidor de telefonia é necessário",
    "ClientConfigurationModal_Tab_Scope_Partition": "Partição",
    "ClientConfigurationModal_Tab_Scope_Device": "Dispositivo",
    "ClientConfigurationModal_Tab_Scope_FilterRecursive": "Filtrar recursivamente",
    "ClientConfigurationModal_Tab_Policy_PolicyItem": "Item de política",
    "ClientConfigurationModal_Tab_Policy_DefaultValue": "Valor padrão",
    "ClientConfigurationModal_Tab_Policy_ActualValue": "Valor real",
    "ClientConfigurationModal_Policy_core": {
        "showUseConfigurationWindow": "Núcleo - Pode mostrar\/usar janela de configuração",
        "permittedToLogin": "Núcleo - Permissão para fazer login"
    },
    "ClientConfigurationModal_Policy_configOptions": {
        "useLocalhostAPI": "Configuração - usar API Localhost",
        "canConfigureCustomEvents": "Config - Configurar eventos personalizados"
    },
    "ClientConfigurationModal_Policy_menuOptions": {
        "canShowAddressBook": "Menu - Catálogo de Endereços"
    },
    "ClientConfigurationModal_Policy_crm": {
        "canAddNewContacts": "Pode adicionar novos contatos aos CRMs (por meio do assistente)"
    },
    "ClientConfigurationModal_Tab_Settings_SettingsItem": "Opção de configuração",
    "ClientConfigurationModal_Tab_Settings_DefaultValue": "Valor padrão",
    "ClientConfigurationModal_Tab_Settings_ActualValue": "Valor real",
    "ClientConfigurationModal_Settings_interface": {
        "showCallNotificationPreview": "Interface - Mostrar visualização de notificação de chamada",
        "showMissedCallPreview": "Interface - Mostrar visualização de chamadas perdidas",
        "connectedHideDelay": "Interface - Atraso de Ocultação Conectado",
        "previewWindowAlwaysOnTop": "Interface - Janela de visualização sempre no topo",
        "showContactInEditMode": "Interface - Mostrar contato no modo de edição",
        "applicationLoadAtWindowsStartup": "Interface - Carregamento do aplicativo na inicialização do Windows"
    },
    "ClientConfigurationModal_Settings_hotkey": {
        "makeCall": "Tecla de atalho - Fazer chamada"
    },
    "ClientConfigurationModal_Settings_dialing": {
        "clipboardDialing": "Discagem - Discagem da área de transferência",
        "focusDialing": "Discagem - Discagem de foco",
        "screenDialing": "Discagem - Discagem de tela"
    },
    "ClientConfigurationModal_Settings_logPage": {
        "sendAnonymouseStats": "Página de Log - Enviar estatísticas anônimas",
        "loggingLevel": "Página de Log - Nível de Log",
        "sendAnonymousStats": "Página de Log - Enviar estatísticas anônimas"
    },
    "ClientConfigurationModal_Settings_version": {
        "checkForUpdates": "Versão - Verifique se há atualizações e faça o download"
    },
    "NAME": "ClientConfigurationModalLanguage",
    "ClientConfigurationModal_Error_NotFound": "Configuração do cliente não encontrada ou inexistente"
}